import { GeneralProvider } from "../GeneralContext";

import { combineComponents } from "./CombineContexts";

const providers = [GeneralProvider];

export const ContextProvider = combineComponents(...providers);
